import { z } from 'zod';

export const orderSheetHistorySearchSchema = z.object({
  search_order_date_from: z.string().min(1, '【発注日開始日】を入力してください。'),
  search_order_date_to: z.string().min(1, '【発注日終了日】を入力してください。'),
});

export type OrderSheetHistorySearchFormData = z.infer<typeof orderSheetHistorySearchSchema>;
